import { LineDetailsApiModel } from './line-details.api-model';
import { CallDetailsApiModel } from './call-details.api-model';
import { CoordinateApiModel } from '../coordinate.api-model';
import type { IServiceJourneyDetails } from '../../../../models/service-journey-details.model';

export class ServiceJourneyDetailsApiModel {
  public static mapToBusinessModel(apiModel: ServiceJourneyDetailsApiModel): IServiceJourneyDetails {
    return {
      gid: apiModel.gid,
      direction: apiModel.direction,
      line: LineDetailsApiModel.mapToBusinessModel(apiModel.line),
      callsOnServiceJourney: apiModel.callsOnServiceJourney ? apiModel.callsOnServiceJourney.map(CallDetailsApiModel.mapToBusinessModel) : undefined,
      serviceJourneyCoordinates: apiModel.serviceJourneyCoordinates ? apiModel.serviceJourneyCoordinates.map(CoordinateApiModel.mapToBusinessModel) : undefined,
    };
  }

  public gid!: string;
  public direction!: string;
  public line!: LineDetailsApiModel;
  public callsOnServiceJourney!: CallDetailsApiModel[];
  public serviceJourneyCoordinates?: CoordinateApiModel[];
}
